module["exports"] = [
  "Slovensko"
];
